import { format } from "date-fns"

export function toISODateString(date: Date = new Date()): string {
  return format(date, "yyyy-MM-dd")
}
